import React, { useRef, createContext } from "react"

import useSiteMetadata from "../hooks/useSiteMetadata"
import { Navigation } from "./Navigation"
import Footer from "./Footer"

import TopBanner from "./TopBanner"

import MainDivRefContext from "../context/MainDivContext"

const Layout = ({
	translucent,
	children,
	navigationOptions,
	footerOptions,
	hideTopBanner = false,
}) => {
	const siteMetadata = useSiteMetadata()

	const mainDivRef = useRef(null)

	return (
		<MainDivRefContext.Provider value={mainDivRef}>
			{!hideTopBanner && <TopBanner />}
			<div className="flex flex-col min-h-screen relative">
				<Navigation
					translucent={translucent}
					siteTitle={siteMetadata.title}
					siteDescription={siteMetadata.description}
					{...navigationOptions}
				/>

				<main
					ref={mainDivRef}
					className="flex-grow selection:bg-solaris selection:text-jetblack bg-white">
					{children}
				</main>

				<div id="modal-root"></div>

				<Footer className="" {...footerOptions} />
			</div>
		</MainDivRefContext.Provider>
	)
}

Layout.defaultProps = {
	translucent: false,
}

export default Layout
